module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout_slight_left.6173bb3d.png";